import jjv from 'jjv'

const validator = jjv()

class ValidationError extends Error {

    constructor(message, validation) {
        super(message)
        Error.captureStackTrace(this, this.constructor)
        this.message = message
        this.validation = validation
    }

    get name() {
        return 'ValidationError'
    }

    get statusCode() {
        return '400'
    }
}

function anyRequired(value, params) {
        if (typeof value == 'object') {
            for (var i = 0 ; i < params.length ; i++) {
                if (value[params[i]] !== undefined) return true
            }
        }
        return false
    }

function validate(schema, object) {
    return new Promise((resolve, reject) => {
        if (object instanceof Array) {
            schema = {
                type: 'array',
                items: schema
            }
        }

        const errors = validator.validate(schema, object, {useDefault: true, removeAdditional: false})

        if (errors) {
            reject(new ValidationError('Validation error', errors.validation))
        } else {
            resolve(object)
        }
    })
}

export {ValidationError, anyRequired}
export default validate


// WEBPACK FOOTER //
// ./lib/core/validate.js